import { t } from "../i18n";
import PropTypes from 'prop-types';
import { Container, Paper, Typography } from '@mui/material';
export default function AuthShell({
  title,
  children
}) {
  return <Container component="main" maxWidth="sm" sx={{
    py: {
      xs: 4,
      sm: 10
    }
  }}>
            <Paper elevation={0} sx={{
      p: {
        xs: 3,
        sm: 5
      },
      border: '1px solid',
      borderColor: 'divider'
    }}>
                <Typography variant="overline" color="primary">{t("ConnectedHeart")}</Typography>
                <Typography component="h1" variant="h4" sx={{
        mt: 1,
        mb: 3
      }}>
                    {t(title)}
                </Typography>
                {children}
            </Paper>
        </Container>;
}
AuthShell.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
